var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "MultiselectAvatar",
    {
      staticClass:
        "flex items-center customAvatraSelected mr-2 mt-1 pr-2 mb-0.5",
      class: _vm.parentStyle,
      attrs: { option: _vm.option },
    },
    [
      _c("RemoveSelectedItemButton", {
        on: {
          remove: function ($event) {
            return _vm.$emit("remove", _vm.option)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }